import { FC } from 'react';
import AddProductProvider from '../memory/memr';
import InitMiddlewareAddBrand from '../middlewares/InitMiddleware';

const AddBrandInstance: FC<{}> = () => {
  return (
    <AddProductProvider>
      <InitMiddlewareAddBrand />
    </AddProductProvider>
  );
};

export default AddBrandInstance;
